import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import environment from "../environment";
import PathConstants from "./pathConstants";

const PrivateRoutesComponent = () => {
  const _token = localStorage.getItem(environment.TOKEN_KEY);
  const isAuthorized = _token;
  return (
    <div>
      {isAuthorized ? <Outlet /> : <Navigate to={PathConstants.Login} />}
    </div>
  );
};

export default PrivateRoutesComponent;
